<script>
import { mapActions } from 'vuex'
import response from '../../fake/volo-hotel-response'
import search from '../../fake/search'
import {EMPTY_FLIGHTS_HOTELS_CHECK, EMPTY_FLIGHTS_CHECK, EMPTY_HOTELS_CHECK} from '../../utils/messages'
import {SERVER_DATE_FORMAT} from '../../utils/formatter'
import {PRODUCT_VOLO_HOTEL} from '../../types/products'
import SearchVoloHotelAction from '../actions/SearchVoloHotelAction'
import {FAKE_ACTIVE} from '../../utils/config'
import BackofficeActions from '../actions/BackofficeAction'
import ServiziActions from '../actions/ServiziAction'
import {clone} from '../../utils/helper'

export default {
  name: 'VoloHotelSearcher',
  mixins: [SearchVoloHotelAction, BackofficeActions, ServiziActions],
  data () {
    return {
      resultMessage: ''
    }
  },
  methods: {
    ...mapActions(['loadFlights', 'loadFlightDepartureInfo', 'loadFlexibleDates', 'loadHotels', 'loadServizi', 'loadTrasferimenti', 'addSearch', 'loadingStart', 'loadingEnd']),
    searchAllVoliHotel (search) {
      return FAKE_ACTIVE ? this.searchFake() : this.searchReal(search)
    },
    searchFake () {
      this.loadingFakeData()
      this.$router.push('/volo-hotel')
      this.$scrollTo('#app')
    },
    makeFlightDepartureInfoFake (servizi, periodHotels) {
      const servizio = clone(servizi[0])
      const date1 = periodHotels[0].period.start
      const date2 = periodHotels[0].period.start
      return {
        arrivalPeriod: {
          start: date1,
          end: date2
        },
        flightTransferService: servizio
      }
    },
    searchReal (search) {
      const payload = {
        type: PRODUCT_VOLO_HOTEL,
        ...search,
        andata: this.$moment(search.andata).format(SERVER_DATE_FORMAT),
        ritorno: this.$moment(search.ritorno).format(SERVER_DATE_FORMAT)
      }
      this.searchVoloHotel(payload).then((response) => {
        const {flightVectorGroups, periodFlights, periodHotels, servizi, flightDepartureInfo} = response.data.object
        // asserts & messages
        const emptyFlight = !flightVectorGroups || flightVectorGroups.length === 0
        const emptyHotel = !periodHotels || periodHotels.length === 0
        if (emptyFlight && emptyHotel) {
          this.resultMessage = EMPTY_FLIGHTS_HOTELS_CHECK
          return
        } else if (emptyFlight) {
          this.resultMessage = EMPTY_FLIGHTS_CHECK
          return
        } else if (emptyHotel) {
          this.resultMessage = EMPTY_HOTELS_CHECK
          return
        }
        if (flightVectorGroups) {
          this.loadFlights(flightVectorGroups)
        }
        // const flightDepartureInfo = this.makeFlightDepartureInfoFake(servizi, periodHotels)
        if (flightDepartureInfo) {
          this.loadFlightDepartureInfo({...flightDepartureInfo, dateSelected: search.andata})
        }
        if (periodFlights && periodFlights.length > 0) {
          this.loadFlexibleDates(periodFlights)
        }
        if (periodHotels && periodHotels.length > 0) {
          this.loadHotels(periodHotels)
        }
        if (servizi && servizi.length > 0) {
          this.loadServizi(servizi)
          this.loadTrasferimenti(servizi)
          const codiciTrasferimenti = this.searchTrasferimentiCodiciFromHotel()
          if (codiciTrasferimenti !== null) {
            // se l'hotel selezionato ha trasferimenti fissi, rimuovo tutti i trasferimenti presenti
            // e aggiungo i trasferimenti fissi
            this.loadTrasferimentiFixed(codiciTrasferimenti, search)
          }
        }
        this.addSearch({type: PRODUCT_VOLO_HOTEL, ...search})
        this.$router.push('/volo-hotel')
        this.$scrollTo('#app')
      })
    },
    loadingFakeData () {
      this.loadFlights(response.object.flightVectorGroups)
      this.loadFlexibleDates(response.object.periodFlights)
      this.loadHotels(response.object.periodHotels)
      this.loadServizi(response.object.servizi)
      this.loadTrasferimenti(response.object.servizi)
      const searchToAdd = {
        ...this.search,
        andata: this.$moment(search.andata, SERVER_DATE_FORMAT).toDate(),
        ritorno: this.$moment(search.ritorno, SERVER_DATE_FORMAT).toDate()
      }
      this.addSearch(searchToAdd)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/searcher/VoloHotelSearcher.vue